import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { format } from 'date-fns';
import { toast } from 'react-toastify';

export default function UserManagement() {
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  const load = () => api.get('/users').then(r => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ role:'Operator' }); setModal('new'); };
  const openEdit = (u) => { setForm({...u, password:''}); setModal('edit'); };
  const openReset = (u) => { setForm({ id:u.id, full_name:u.full_name, new_password:'' }); setModal('reset'); };

  const save = async e => {
    e.preventDefault(); setSaving(true);
    try {
      if (modal === 'new') await api.post('/users', form);
      else if (modal === 'edit') await api.put(`/users/${form.id}`, form);
      else await api.patch(`/users/${form.id}/reset-password`, { new_password: form.new_password });
      toast.success('Saved'); setModal(null); load();
    } catch(err) { toast.error(err.response?.data?.message || 'Failed'); }
    finally { setSaving(false); }
  };

  const toggleActive = async (u) => {
    try { await api.patch(`/users/${u.id}/toggle-active`); toast.success(u.is_active ? 'Deactivated' : 'Activated'); load(); }
    catch(err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  return (
    <div>
      <div className="page-header">
        <div><h2>User Management</h2><p>Manage system users and roles</p></div>
        <button className="btn btn-primary" onClick={openNew}>+ Add User</button>
      </div>

      <div className="card" style={{padding:0}}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th>Last Login</th><th>Actions</th></tr></thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td className="fw-bold">{u.full_name}</td>
                  <td>{u.email}</td>
                  <td><span className={`badge ${u.role==='Admin'?'badge-red':u.role==='Operator'?'badge-blue':'badge-gray'}`}>{u.role}</span></td>
                  <td><span className={`badge ${u.is_active?'badge-green':'badge-red'}`}>{u.is_active?'Active':'Inactive'}</span></td>
                  <td className="text-muted">{u.last_login ? format(new Date(u.last_login),'dd/MM/yyyy HH:mm') : 'Never'}</td>
                  <td>
                    <div className="btn-group">
                      <button className="btn btn-outline btn-xs" onClick={()=>openEdit(u)}>Edit</button>
                      <button className="btn btn-outline btn-xs" onClick={()=>openReset(u)}>Reset Pwd</button>
                      <button className={`btn btn-xs ${u.is_active?'btn-danger':'btn-success'}`} onClick={()=>toggleActive(u)}>{u.is_active?'Deactivate':'Activate'}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={()=>setModal(null)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <h3>{modal==='new'?'Add User':modal==='edit'?'Edit User':'Reset Password'}</h3>
              <button className="btn-icon" onClick={()=>setModal(null)}>✕</button>
            </div>
            <form onSubmit={save}>
              {modal !== 'reset' && <>
                <div className="form-group"><label>Full Name <span className="req">*</span></label><input className="form-control" value={form.full_name||''} onChange={e=>setForm({...form,full_name:e.target.value})} required /></div>
                <div className="form-group"><label>Email <span className="req">*</span></label><input className="form-control" type="email" value={form.email||''} onChange={e=>setForm({...form,email:e.target.value})} required /></div>
                <div className="form-group"><label>Role</label>
                  <select className="form-control" value={form.role||'Operator'} onChange={e=>setForm({...form,role:e.target.value})}>
                    {['Admin','Operator','Viewer'].map(r=><option key={r}>{r}</option>)}
                  </select>
                </div>
              </>}
              {modal === 'new' && <div className="form-group"><label>Password <span className="req">*</span></label><input className="form-control" type="password" value={form.password||''} onChange={e=>setForm({...form,password:e.target.value})} required /></div>}
              {modal === 'reset' && <>
                <p style={{color:'var(--text-muted)',marginBottom:'12px'}}>Reset password for: <b>{form.full_name}</b></p>
                <div className="form-group"><label>New Password <span className="req">*</span></label><input className="form-control" type="password" value={form.new_password||''} onChange={e=>setForm({...form,new_password:e.target.value})} required minLength={6} /></div>
              </>}
              <div className="btn-group mt-2">
                <button className="btn btn-primary" type="submit" disabled={saving}>{saving?'Saving...':'Save'}</button>
                <button className="btn btn-secondary" type="button" onClick={()=>setModal(null)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
